import { useState } from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import Text from '/src/components/@common.blocks/Text'
import AssetTraits from '/src/components/@common.blocks/AssetTraits'
import Skeleton from '/src/components/@common.blocks/Skeleton'
import { cutAddress } from '/src/helpers/formatter'

const ImagePlaceholder = ({ logo, name }) => {
  return (
    <div className='asset-placeholder'>
      <div />
      <img className='asset-placeholder__logo' src={logo} alt={name} />
    </div>
  )
}

const AssetRankCard = (props) => {
  const [imageLoading, setImageLoading] = useState(!!props.image)
  const {
    name,
    tokenId,
    image,
    owner,
    ownerName,
    traits,
    totalScore,
    rank,
    openseaUrl,
    supply,
    logo,
  } = props

  const ownerFormatted = ownerName ? ownerName : cutAddress(owner)

  return (
    <div className='asset-rank-card'>
      <div className='asset-rank-card__grid'>
        <div className='asset-rank-card__image'>
          <Skeleton loading={imageLoading}>
            {image && (
              <Image
                src={image}
                alt={name}
                layout='fill'
                onLoadingComplete={() => setImageLoading(false)}
              />
            )}
            {!image && <ImagePlaceholder name={name} logo={logo} />}
          </Skeleton>
        </div>
        <div className='asset-rank-card__name'>
          <Text>{name || `#${tokenId}`}</Text>
          <a
            href={`https://opensea.io/${owner}`}
            target='_blank'
            rel='noreferrer'
            className='text text_color_light-gray'
          >
            {ownerFormatted}
          </a>
        </div>
        <a
          className='button button_color_default asset-rank-card__opensea'
          href={openseaUrl}
          target='_blank'
          rel='noreferrer'
        >
          <img src='/icons/opensea.svg' alt='opensea' />
          View on OpenSea
        </a>
        <div className='asset-rank-card__grid-item'>
          <div className='asset-rank-card__header'>
            <Text className='asset-rank-card__rank'>{`Rank #${rank}`}</Text>
            <Text color='light-gray'>{`Rarity Score: ${Number(
              totalScore
            ).toFixed(2)}`}</Text>
          </div>
          <AssetTraits traits={traits || []} supply={supply} />
        </div>
      </div>
    </div>
  )
}

AssetRankCard.propTypes = {
  name: PropTypes.string,
  tokenId: PropTypes.number,
  image: PropTypes.string,
  owner: PropTypes.string,
  traits: PropTypes.object,
  rarityScore: PropTypes.number,
  rank: PropTypes.number,
  openseaUrl: PropTypes.string,
}

export default AssetRankCard
